import React from 'react'
import Button from '../button/Button'
import { VerifyAchCardActions, VerifyAchCardContainer, VerifyAchCardContent, VerifyAchCardOlItem, VerifyAchCardOlList, VerifyAchCardText, VerifyAchCardTitle } from './Theme'

const VerifyAchCardInfo = ({
  closeModal,
}) => {
  return (
    <VerifyAchCardContainer>
      <VerifyAchCardTitle>Verify Your ACH Account</VerifyAchCardTitle>
      <VerifyAchCardContent>
        <VerifyAchCardText>
          To complete the verification, check your bank statement for one or two micro deposit amounts sent by us.
        </VerifyAchCardText>
        <div>
          {/* <VerifyAchCardText>Verify ACH Microdeposits</VerifyAchCardText> */}
          <VerifyAchCardOlList>
            <VerifyAchCardOlItem>Wait until deposits appear in your bank (usually within 1–2 business days).</VerifyAchCardOlItem>
            <VerifyAchCardOlItem>Log in → <b>Settings</b> → <b>Payment Methods</b></VerifyAchCardOlItem>
            <VerifyAchCardOlItem>Select <b>ACH account</b></VerifyAchCardOlItem>
            <VerifyAchCardOlItem>Enter the micro-deposit amounts that were sent to your account or 6-digit code in the statement descriptor of this deposit.</VerifyAchCardOlItem>
            <VerifyAchCardOlItem>Once the info is entered, you may submit verification</VerifyAchCardOlItem>
          </VerifyAchCardOlList>
        </div>
        <VerifyAchCardText>
          Thank you for verifying your account!
        </VerifyAchCardText>
      </VerifyAchCardContent>
      <VerifyAchCardActions>
        <Button
          onClick={closeModal}
          variant="primary"
          size="md"
          style={{
            minWidth: 80,
          }}
        >
          <span>Ok</span>
        </Button>
      </VerifyAchCardActions>
    </VerifyAchCardContainer>
  )
}

export default VerifyAchCardInfo